
export const personalCenter = {
    title: '个人中心',
    subtitle: '管理您的帐户、积分、邀请和订单',
    myCredits: '我的积分',
    myInvites: '我的邀请',
    myOrders: '我的订单',
    mySubscriptionsTab: '我的订阅',
    myProfile: {
      title: '我的资料',
      description: '管理您的个人信息和头像',
      avatarSettings: '头像设定',
      basicInformation: '基本信息',
      loadingProfile: '加载资料中...',
      loadingFailed: '加载失败',
      retry: '重试',
      uploading: '上传中...',
      clickToUpload: '点击上传',
      cancel: '取消',
      cancelUpload: '取消上传',
      supportedFormats: '支持 JPG、JPEG、PNG、GIF、WEBP 格式',
      fileSizeLimit: '文件大小不应超过 5MB',
      uploadSuccess: '头像修改成功'
    },
    userInfo: {
      unknown: '未知',
      googleAccount: 'Google 帐户',
      emailRegistration: '邮箱注册',
      unknownMethod: '未知方式',
      verified: '已验证',
      unverified: '未验证',
      emailAddress: '邮箱地址',
      registrationMethod: '注册方式',
      registrationDate: '注册日期'
    },
    mySubscriptions: {
      title: '我的订阅',
      description: '管理您的订阅计划和账单',
      loading: '加载订阅信息中...',
      retry: '重试',
      noSubscriptions: '暂无活跃订阅',
      noSubscriptionsDesc: '您目前没有任何活跃的订阅。浏览我们的方案开始使用。',
      browsePlans: '浏览方案',
      price: '价格',
      startDate: '开始日期',
      nextBilling: '下次扣款',
      endDate: '结束日期',
      cancelSubscription: '取消订阅',
      manageOnPayPal: '在PayPal管理',
      manageOnStripe: '在Stripe管理',
      confirmCancel: '您确定要取消此订阅吗？此操作无法撤销。',
      cancelSuccess: '订阅已成功取消',
      cancelError: '取消订阅失败，请重试。',
      status: {
        active: '活跃',
        cancelled: '已取消',
        suspended: '已暂停',
        expired: '已过期'
      }
    }
  };
